var swiper = new Swiper(".makeUnique", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1.4,
      spaceBetween: 10,
      slidesOffsetAfter: 40,
    },
    768: {
      slidesPerView: 3.5,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  var contentParts = document.querySelectorAll(".contentpart");

  contentParts.forEach(function (part) {
    var p = part.querySelector("p");
    var button = part.querySelector("button");
    var fullContent = p.innerText;
    var shortContent = fullContent.substring(0, 100) + "...";

    p.innerText = shortContent;

    button.addEventListener("click", function () {
      if (button.innerText === "Read More") {
        p.innerText = fullContent;
        button.innerText = "Read Less";
      } else {
        p.innerText = shortContent;
        button.innerText = "Read More";
      }
    });
  });
});
